import { Component } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Http } from "@angular/http";
import { ErrorHandler } from "../../shared/services/error-handler.service";
import { HttpService } from "../../shared/services/http.service";
import { SessionHandler } from "../../shared/services/session-handler.service";
import { CommonService } from "../../shared/services/common.service";
import { itemClass, itemClassEditManual } from "./foc-itemClass";
import { MdDialog } from "@angular/material";
import { dialogComponent } from "../../dialog/dialog.component";

@Component({
    selector: 'request-add',
    template: require('./foc-return.component.html'),
    styles: [require('./foc-return.component.scss')],
    providers: [HttpService, ErrorHandler, SessionHandler]
})

export class FOCviewRequestReturnComponent {


    userData: any;
    reasonList: any;
    dialogRef;
    requestFormData: any = {}
    showInsertButton: boolean = true;
    invoice_no: any;
    showInvoiceReturn: boolean = false;
    item_list: any = [];
    itemReason = [];
    enableBtn: boolean = false;
    isItem: boolean = false;
    itemLength: number = 0;
    modelNumber: any;
    serialNumber: any;
    quantity: any = "1";
    returnOrder: any;
    listBtnEnable: boolean = false;
    invoiceBtnEnable: boolean = false;
    itemQuantity = [];
    itemQuantityList = [];
    enableItemReason = [];
    manualListValid = [];
    listLoader = [];
    manualListError = [];
    isUpload=true;
    isManual: boolean = false;
    showField: any = [];
    serialNumberList = [];
    itemError: boolean = false;
    serialNumberInput: any = [];
    showEditSerial = [];
    tempSerialList = [];
    return_reason: any;
    id: any;
    formData: any;
    showManualList: boolean = false;
    isD2CUser=false;
    constructor(private router: Router, private route: ActivatedRoute, private Http: Http, private http: HttpService, private commonService: CommonService, private sessionHandler: SessionHandler,
        private dialog: MdDialog) {

        this.returnOrder = {};
        this.userData = {};
        if (this.http.checkSession()) {
            this.userData = JSON.parse(this.sessionHandler.getItem('loginData'));
            this.route.params.subscribe(params => {
                this.id = +params['id'];
            });
            let data = this.commonService.getData();
            console.log(data)
            if (!isNaN(this.id)) {
                if (data && data['focProductList']) {
                    this.isD2CUser=data.d2C;/**added for  D2c one time address */
                    this.formData = data;
                    this.commonService.changeViewData(this.formData);
                    this.returnOrder = data['focProductList'];
                    console.log("here   ",this.returnOrder)
                    if (this.formData.returnItemUploadFlag == 2 || this.formData.returnItemUploadFlag == 'INVOICE_NUMBER') {
                        this.setReturnData();
                    } else if (this.formData.returnItemUploadFlag == 0 || this.formData.returnItemUploadFlag == 1 || this.formData.returnItemUploadFlag == 'INSERT_MANUAL' || this.formData.returnItemUploadFlag == 'UPLOAD_FILE') {
                        this.setReturnDataManual();
                    }
                    // this.setReturnData();
                } else {
                    this.getRequestDataWithId();
                }
            }
        } else {
            this.http.showSessionError();
        }
    }

    ngOnInit() { 
        this.getRequestDataWithId();

    }

    public getRequestDataWithId() {
        console.log("####")
        this.http.getRequest('focApi/v1/getFOCRequestDetail?FOCId='+ this.id)
        .subscribe(
            res => {this.saveRequestData(res)
                console.log("####")
            
            },
            err => {
                if(err && err.status!=0){
                    this.dialogRef = this.dialog.open(dialogComponent);
                    this.dialogRef.componentInstance.msg = err;

                }
                this.http.onEnd();
        });        
        
    }
    public saveRequestData(res) {
        if (res.status == 'Success') {
            this.returnOrder = res.FOCRequestDetail;
            this.formData = res.FOCRequestDetail;
            this.commonService.changeViewData(this.formData);
    
            // FIX: Ensure item_list is populated
            if (this.returnOrder.focProductList && this.returnOrder.focProductList.length > 0) {
                this.item_list = [ this.returnOrder.focProductList ]; // nested array for UI
            } else {
                this.item_list = [];
            }
        }
        this.http.onEnd();
    }
    
    
    public getReasonList() {
        this.http.getRequest('tradePartnerDetails/v1/getReasonCode')
            .subscribe(
                res => { this.saveReasonList(res) },
                err => {
                    if(err && err.status!=0){
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = err;

                    }
                    this.http.onEnd();
                });
    }

    public saveReasonList(res) {
        if (res && res.items) {
            this.reasonList = res.items;
            this.sessionHandler.saveItem('reasons', JSON.stringify(this.reasonList));
            for (let r in this.reasonList) {
                if (this.returnOrder.reason == this.reasonList[r].reasonCode) {
                    this.return_reason = this.reasonList[r].reason;
                }
            }
        }
        this.http.onEnd();
    }

    public setReturnData() {
        // 1. Load reason list (unchanged)
        this.reasonList = JSON.parse(this.sessionHandler.getItem('reasons'));
        if (!this.reasonList || this.reasonList.length < 1) {
          this.getReasonList();
        } else {
          const r = this.reasonList.find(x => x.reasonCode === this.returnOrder.reason);
          this.return_reason = r ? r.reason : null;
        }
      
        // 2. Upload/manual flag handling (unchanged)
        if (this.formData.returnItemUploadFlag == 'INSERT_MANUAL' || this.formData.returnItemUploadFlag == 0) {
          this.isManual = true;
        } else if (this.formData.returnItemUploadFlag == 'UPLOAD_FILE' || this.formData.returnItemUploadFlag == 1) {
          this.isUpload = true;
        } else if (this.formData.returnItemUploadFlag == 'INVOICE_NUMBER' || this.formData.returnItemUploadFlag == 2) {
          this.invoice_no = this.returnOrder.invoiceNumber;
          this.showInvoiceReturn = true;
        } else {
          this.isManual = true;
        }
      
        // 3. SAFELY extract actual items (fixes nested structures)
        const raw = (this.returnOrder.items || []).map(it =>
          it && it.data ? it.data : it
        );
      
        // 4. NORMALIZE each item (THIS is the fix!)
        this.item_list = raw.map(x => ({
          modelNumber: x.modelNumber || x.customerMaterialNumber || '',
          itemID: x.itemID || '',
          quantity: Number(x.invoicedQuantity || x.quantity || 0),   // <-- NEVER GROUPED
          serialNumber: Array.isArray(x.serialNumber) ? [...x.serialNumber] : [],
          cost: x.cost || 0,
          reasonCode: x.reasonCode || null,
          currency: x.currency || null,
          done: true
        }));
      
        // 5. Show manual list if needed
        this.showManualList = true;
      
        console.log("FINAL FIXED ITEM LIST (RETURN PAGE):", this.item_list);
      }
      

    //FOR MANUAL ENTRIES
    public setReturnDataManual() {
        this.reasonList = JSON.parse(this.sessionHandler.getItem('reasons'));
        if (this.reasonList == null || this.reasonList.length < 0) {
            this.getReasonList();
        } else {
            for (let r in this.reasonList) {
                if (this.returnOrder.reason == this.reasonList[r].reasonCode) {
                    this.return_reason = this.reasonList[r].reason;
                }
            }
        }
        if (this.requestFormData.returnItemUploadFlag == 'INSERT_MANUAL' || this.requestFormData.returnItemUploadFlag == '0' || this.requestFormData.returnItemUploadFlag == 0) {
            this.isManual = true;
        } else if (this.requestFormData.returnItemUploadFlag == 'UPLOAD_FILE' || this.requestFormData.returnItemUploadFlag == '1' || this.requestFormData.returnItemUploadFlag == 1) {
            this.isUpload = true;
        } else if (this.requestFormData.returnItemUploadFlag == 'INVOICE_NUMBER' || this.requestFormData.returnItemUploadFlag == '2' || this.requestFormData.returnItemUploadFlag == 2) {
            this.invoice_no = this.returnOrder.invoiceNumber;
            this.showInsertButton = false;
            this.showInvoiceReturn = true;
        } else {
            this.isManual = true;
        }

        if (this.returnOrder.items) {
            this.item_list = Object.assign([], this.returnOrder.items);
            if (this.item_list && this.item_list.length > 0) {
                if (this.item_list[0].modelNumber) {
                    this.setItemListManual();
                } else {
                    this.setItemDataForEditManual();
                }
            }
        }
        this.showManualList = true;
    }

    public deleteManual(index) {
        this.itemQuantityList.splice(index, 1);
        this.itemQuantity.splice(index, 1);

        this.serialNumberList.splice(index, 1);
        this.serialNumberInput.splice(index, 1);
        this.showEditSerial.splice(index, 1);

        this.itemReason.splice(index, 1);
        this.enableItemReason.splice(index, 1);
        this.item_list.splice(index, 1);
    }

    public setItemListManual() {
        for (let i in this.item_list) {
            if (parseInt(this.item_list[i].invoicedQuantity) > 0) {
                this.enableItemReason[i] = true;
                this.showEditSerial[i] = false;
                this.serialNumberList[i] = [];
                if (this.isManual) {
                    this.item_list[i].done = true;
                }
                // if (this.item_list[i].serialNumber && Object.keys(this.item_list[i].serialNumber).length > 0) {
                //     for (let x in this.item_list[i].serialNumber) {
                //         if (this.item_list[i].serialNumber[x] && Object.keys(this.item_list[i].serialNumber[x]).length > 0) {
                //             if (!this.isItemInArray(this.serialNumberList[i], this.item_list[i].serialNumber[x].value)) {
                //                 this.serialNumberList[i].push(this.item_list[i].serialNumber[x]);
                //             }
                //         }
                //     }
                // }
                for (let q in this.itemQuantityList[i]) {
                    if (this.itemQuantityList[i][q] == this.item_list[i].invoicedQuantity) {
                        this.itemQuantity[i] = this.itemQuantityList[i][q];
                    }
                }
                let count = 0;
                for (let x in this.serialNumberList[i]) {
                    if (this.serialNumberList[i][x].value && this.serialNumberList[i][x].value != '') {
                        count++;
                    }
                }
                if (count < parseInt(this.item_list[i].invoicedQuantity)) {
                    this.showEditSerial[i] = true;
                }
                if (this.item_list[i].reasonCode) {
                    this.itemReason[i] = this.item_list[i].reasonCode;
                }
            }
        }
    }

    public setItemDataForEditManual() {
        console.log(this.item_list);
        if (this.item_list) {
            let serials: any = [];
            let qty: any = [];
            let models: any = [];
            let final: any = [];
            let items: itemClassEditManual[] = [];
            let itemList: any = [];
            for (let i in this.item_list) {
                if (this.item_list[i]) {
                    if (!this.item_list[i].id) {
                        this.item_list[i].id = '';
                    }
                    let reason = null;
                    if (this.item_list[i].reasonCode) {
                        reason = this.item_list[i].reasonCode;
                    }
                    let maxQuantity = '';
                    if (this.item_list[i].maxQuantity && this.item_list[i].maxQuantity != '') {
                        maxQuantity = this.item_list[i].maxQuantity
                    }
                    if (this.item_list[i].serialNumber) {
                        items.push(new itemClassEditManual(this.item_list[i].id, this.item_list[i].customerMaterialNumber, this.item_list[i].serialNumber, this.item_list[i].itemID, reason, this.item_list[i].invoicedQuantity, maxQuantity, true));
                    } else {
                        items.push(new itemClassEditManual(this.item_list[i].id, this.item_list[i].customerMaterialNumber, null, this.item_list[i].itemID, reason, this.item_list[i].invoicedQuantity, maxQuantity, true));
                    }
                }
            }

            for (let i in items) {
                console.log(items);
                if (models.indexOf(items[i].modelNumber) == -1) {
                    models.push(items[i].modelNumber);
                }
            }

            for (let m in models) {
                serials[models[m]] = [];
                qty[models[m]] = 0;
                for (let i in items) {
                    let rawSerial = {};
                    if (models[m] == items[i].modelNumber) {
                        qty[models[m]] = parseInt(items[i].invoicedQuantity);
                        if (items[i].id) {
                            rawSerial['id'] = items[i].id;
                        } else {
                            rawSerial['id'] = '';
                        }
                        if ((items[i].serialNumber)) {
                            rawSerial['value'] = items[i].serialNumber;
                        } else {
                            rawSerial['value'] = '';
                        }
                        serials[models[m]].push(rawSerial);
                    }
                }
            }

            for (let m in models) {
                for (let i in items) {
                    if (models[m] == items[i].modelNumber) {
                        final[i] = [];
                        final[i] = items[i];
                        break;
                    }
                }
            }

            for (let f in final) {
                for (let s in serials) {
                    if (final[f].modelNumber == s) {
                        final[f].invoicedQuantity = qty[s];
                        final[f].serialNumber = serials[s];
                    }
                }
                itemList.push(final[f]);
            }
            this.item_list = items;

            for (let i in this.item_list) {
                this.itemQuantityList[i] = [];
                let loopCount = 0;
                if (this.item_list[i].maxQuantity && this.item_list[i].maxQuantity != '') {
                    loopCount = parseInt(this.item_list[i].maxQuantity);
                } else {
                    loopCount = this.item_list[i].invoicedQuantity;
                }
                for (var x = 0; x <= loopCount; x++) {
                    this.itemQuantityList[i].push(x);
                }
            }
            console.log(this.item_list);
            if (this.item_list && this.item_list.length > 0) {
                this.setItemListManual();
            }
        }
    }
    // END Maual Functions

    public isItemInArray(array, item) {
        for (var i = 0; i < array.length; i++) {
            // This if statement depends on the format of your array
            if (array[i].value == item) {
                return true;   // Found it
            }
        }
        return false;   // Not found
    }

    public goToNextPage() {
        const cloned = JSON.parse(JSON.stringify(this.formData));
        this.commonService.setData(cloned);
        this.router.navigateByUrl('/app/foc-view/confirm/' + this.id);
    }
    

    public goToPreviousPage() {
        this.router.navigateByUrl('/app/foc-view/create/' + this.id);
    }
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/FOCviewRequest/foc-return/foc-return.component.ts